<template>
    <span
        class="w-full text-xs text-gray-400"
    >
        {{ dispatchType === DispatchTypeOrderBuddy.DELIVER ? !webshopSettings().deliveryIsEnabled ? capitalize($t('cart.notAvailable')) : `${$t('homePage.from')} ${handleFiveMinutesMinus(webshopSettings().global.minimumDeliveryTime)} - ${webshopSettings().global.minimumDeliveryTime} min` : !webshopSettings().pickupIsEnabled ? capitalize($t('cart.notAvailable')) : `${$t('homePage.from')} ${handleFiveMinutesMinus(webshopSettings().global.minimumPickupTime)} - ${webshopSettings().global.minimumPickupTime} min` }}
    </span>
</template>

<script lang="ts" setup>
    import capitalize from 'lodash.capitalize'
    import { webshopSettings } from '~/store/webshopSettings'
    import { DispatchTypeOrderBuddy } from '~/types/orderbuddy-types'
    defineProps({
        dispatchType: {
            type: String as () => DispatchTypeOrderBuddy,
            required: true
        }
    })
    function handleFiveMinutesMinus (minutes: number) {
        return minutes === 0 ? 0 : minutes - 5
    }
</script>
